import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Clock, XCircle } from "lucide-react";
import { fmtMoney } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PortalPaymentSuccess() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "checking", attempts: 0 });
  useEffect(() => {
    if (!sessionId) return setState({ status: "error" });
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") return setState({ ...r.data, status: "paid" });
        if (["failed", "expired"].includes(r.data.payment_status)) return setState({ ...r.data, status: "failed" });
      } catch {}
      if (++attempts < 8) setTimeout(poll, 2000); else setState({ status: "pending" });
    };
    poll();
  }, [sessionId]);
  const S = { checking: [Clock, "Confirming your payment…", "Please wait while we confirm the payment with Stripe."], paid: [CheckCircle2, "Payment received — thank you", `Your payment${state.amount ? ` of ${fmtMoney(state.amount)}` : ""} for ${state.invoice_number || "your invoice"} has been recorded and a receipt is logged on your file.`], pending: [Clock, "Payment is processing", "Your payment has been submitted and will appear in your portal shortly."], failed: [XCircle, "Payment not completed", "The payment was cancelled or declined. You can try again from your portal."], error: [XCircle, "Missing payment reference", ""] }[state.status];
  const Icon = S[0];
  return (
    <div className="min-h-screen bg-[#F4F6F9] flex items-center justify-center p-6" data-testid="portal-payment-result">
      <div className="bg-white rounded-lg shadow-xl p-10 max-w-lg text-center fade-in">
        <Icon className={`w-14 h-14 mx-auto ${state.status === "paid" ? "text-emerald-600" : state.status === "failed" ? "text-red-500" : "text-[var(--brand)]"}`} />
        <h1 className="font-serif text-3xl text-[#0B132B] mt-4" data-testid="portal-payment-title">{S[1]}</h1>
        <p className="text-slate-600 mt-2 text-sm">{S[2]}</p>
        <Link to={`/portal/${token}`} className="inline-block mt-8 bg-[#0B132B] text-white px-5 py-2.5 rounded font-semibold text-sm" data-testid="portal-back-link">Back to my portal</Link>
      </div>
    </div>
  );
}
